import $http from '@/resource';
import utils from '@/utils';

const $api = {};

//个人数据
$api.getUserDatas = async (uid, searchData) => {
    const url=`user-datas/${uid}?${utils.objToUrlParams(searchData)}`;
    let res = await $http.get(url);
    if (res.code === "200") {
        return res;
    } else {
        utils.notice(res.msg, 'error');
    }
};

$api.getUserCloudList = async (uid, searchData) => {
    const url=`data-clouds/${uid}?${utils.objToUrlParams(searchData)}`;
    let res = await $http.get(url);
    if (res.code === "200") {
        return res;
    } else {
        utils.notice(res.msg, 'error');
    }
};

$api.getUserDataAddList = async (uid, searchData) => {
    const url=`datas/add-lists/${uid}?${utils.objToUrlParams(searchData)}`;
    let res = await $http.get(url);
    if (res.code === "200") {
        return res;
    } else {
        utils.notice(res.msg, 'error');
    }
};

$api.getUserDataCloudList = async (uid, searchData) => {
    const url=`datas/cloud-lists/${uid}?${utils.objToUrlParams(searchData)}`;
    let res = await $http.get(url);
    if (res.code === "200") {
        return res;
    } else {
        utils.notice(res.msg, 'error');
    }
};

//全局数据
$api.getAllDatas = async(searchData) => {
    const url=`company-datas?${utils.objToUrlParams(searchData)}`;
    let res = await $http.get(url);
    if (res.code === "200") {
        return res;
    } else {
        utils.notice(res.msg, 'error');
    }
}

//全局录入项目
$api.getAllDataAddList = async (searchData) => {
    const url=`datas/all-add-lists?${utils.objToUrlParams(searchData)}`;
    let res = await $http.get(url);
    if (res.code === "200") {
        return res;
    } else {
        utils.notice(res.msg, 'error');
    }
};

//全局跟进项目
$api.getAllDataCloudList = async (searchData) => {
    const url=`datas/all-cloud-lists?${utils.objToUrlParams(searchData)}`;
    let res = await $http.get(url);
    if (res.code === "200") {
        return res;
    } else {
        utils.notice(res.msg, 'error');
    }
};

export default $api;


// WEBPACK FOOTER //
// ./src/service/datas/index.js